<app-header></app-header>

  <!-- Banner Start -->
  <div class="banner banner-1 bg-cover">

    <div class="imgs-wrapper">
      <img src="assets/img/veg/11.png" alt="veg" class="d-none d-lg-block">
    </div>

    <div class="banner-slider">

      <div class="banner-item">
        <div class="banner-inner">
          <div class="container">
            <div class="row align-items-center">
              <div class="col-xl-6 col-lg-6">
                <h1 class="title">Truly Italian</h1>
                <h4>Pepperoni Pizza With Thin Crust</h4>
                <p class="subtitle">
                  Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard
                </p>
                <div class="banner-icons-wrapper">
                  <div class="banner-icon">
                    <i class="flaticon-calories"></i>
                    <div class="banner-icon-body">
                      <h5>480</h5>
                      <span>Calories</span>
                    </div>
                  </div>
                  <div class="banner-icon">
                    <i class="flaticon-cheese"></i>
                    <div class="banner-icon-body">
                      <h5>120g</h5>
                      <span>Mozarella</span>
                    </div>
                  </div>
                </div>
                <div class="banner-controls">
                  <a href="#" class="btn-custom primary">Order <i class="flaticon-shopping-bag"></i> </a>
                  <h4>$10.99</h4>
                </div>
              </div>
              <div class="col-xl-6 col-lg-6">
                <img src="assets/img/prods/3.png" alt="pizza">
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="banner-item">
        <div class="banner-inner">
          <div class="container">
            <div class="row align-items-center">
              <div class="col-xl-6 col-lg-6">
                <h1 class="title">Wilderness Bless</h1>
                <h4>Ham & Cheese With Vegetables</h4>
                <p class="subtitle">
                  Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard
                </p>
                <div class="banner-icons-wrapper">
                  <div class="banner-icon">
                    <i class="flaticon-calories"></i>
                    <div class="banner-icon-body">
                      <h5>800g</h5>
                      <span>Calories</span>
                    </div>
                  </div>
                  <div class="banner-icon">
                    <i class="flaticon-cheese"></i>
                    <div class="banner-icon-body">
                      <h5>300g</h5>
                      <span>Mozarella</span>
                    </div>
                  </div>
                </div>
                <div class="banner-controls">
                  <a href="#" class="btn-custom primary">Order <i class="flaticon-shopping-bag"></i> </a>
                  <h4>$17.99</h4>
                </div>
              </div>
              <div class="col-xl-6 col-lg-6">
                <img src="assets/img/prods/5.png" alt="pizza">
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="banner-item">
        <div class="banner-inner">
          <div class="container">
            <div class="row align-items-center">
              <div class="col-xl-6 col-lg-6">
                <h1 class="title">Green Delight</h1>
                <h4>Vegetarian Pizza With Thin Crust</h4>
                <p class="subtitle">
                  Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard
                </p>
                <div class="banner-icons-wrapper">
                  <div class="banner-icon">
                    <i class="flaticon-calories"></i>
                    <div class="banner-icon-body">
                      <h5>230</h5>
                      <span>Calories</span>
                    </div>
                  </div>
                  <div class="banner-icon">
                    <i class="flaticon-cheese"></i>
                    <div class="banner-icon-body">
                      <h5>100g</h5>
                      <span>Mozarella</span>
                    </div>
                  </div>
                </div>
                <div class="banner-controls">
                  <a href="#" class="btn-custom primary">Order <i class="flaticon-shopping-bag"></i> </a>
                  <h4>$6.99</h4>
                </div>
              </div>
              <div class="col-xl-6 col-lg-6">
                <img src="assets/img/prods/2.png" alt="pizza">
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="banner-item">
        <div class="banner-inner">
          <div class="container">
            <div class="row align-items-center">
              <div class="col-xl-6 col-lg-6">
                <h1 class="title">Feeling Cheesy</h1>
                <h4>Pepperoni Pizza With Four Cheeses</h4>
                <p class="subtitle">
                  Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard
                </p>
                <div class="banner-icons-wrapper">
                  <div class="banner-icon">
                    <i class="flaticon-calories"></i>
                    <div class="banner-icon-body">
                      <h5>650</h5>
                      <span>Calories</span>
                    </div>
                  </div>
                  <div class="banner-icon">
                    <i class="flaticon-cheese"></i>
                    <div class="banner-icon-body">
                      <h5>200g</h5>
                      <span>Mozarella</span>
                    </div>
                  </div>
                </div>
                <div class="banner-controls">
                  <a href="#" class="btn-custom primary">Order <i class="flaticon-shopping-bag"></i> </a>
                  <h4>$12.99</h4>
                </div>
              </div>
              <div class="col-xl-6 col-lg-6">
                <img src="assets/img/prods/1.png" alt="pizza">
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="banner-slider-nav">
      <div class="container">

        <!-- Arrow -->
        <i class="slider-prev fas fa-arrow-left slick-arrow"></i>

        <div class="banner-slider-nav-inner">

          <div class="banner-nav-item">
            <div class="banner-nav-item-inner">
              <img src="assets/img/prods/3.png" alt="pizza">
              <div class="banner-nav-item-body">
                <h5>Specialty</h5>
                <span>$10.99</span>
              </div>
            </div>
          </div>

          <div class="banner-nav-item">
            <div class="banner-nav-item-inner">
              <img src="assets/img/prods/5.png" alt="pizza">
              <div class="banner-nav-item-body">
                <h5>Ham & Cheese</h5>
                <span>$17.99</span>
              </div>
            </div>
          </div>

          <div class="banner-nav-item">
            <div class="banner-nav-item-inner on-sale">
              <div class="sale">
                <div class="sale-inner">
                  Offer
                </div>
              </div>
              <img src="assets/img/prods/2.png" alt="pizza">
              <div class="banner-nav-item-body">
                <h5>Vegetarian</h5>
                <span>$9.99</span>
                <span>$6.99</span>
              </div>
            </div>
          </div>

          <div class="banner-nav-item">
            <div class="banner-nav-item-inner">
              <img src="assets/img/prods/1.png" alt="pizza">
              <div class="banner-nav-item-body">
                <h5>Pepperoni</h5>
                <span>$12.99</span>
              </div>
            </div>
          </div>

        </div>

        <!-- Arrow -->
        <i class="slider-next fas fa-arrow-right slick-arrow"></i>

      </div>
    </div>

  </div>
  <!-- Banner End -->

  <!-- About us start -->
  <div class="section">
    <div class="container">
      <div class="row align-items-center">

        <div class="col-lg-6 mb-lg-30 ct-single-img-wrapper">
          <img src="assets/img/auth.jpg" alt="img">
          <div class="ct-dots"></div>
        </div>
        <div class="col-lg-6">
          <div class="section-title-wrap mr-lg-30">
            <h5 class="custom-primary">Sir Slice's Heritage</h5>
            <h2 class="title">Serving Pizzas By The Slice Since 1987</h2>
            <p class="subtitle">
              Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s Lorem Ipsum is simply dummy text of the printing and typesetting industry.
            </p>
            <p class="subtitle">
              Lorem Ipsum has been the industry's standard dummy text ever since the 1500s
            </p>
            <div class="signature">
              <img src="assets/img/signature.png" alt="signature">
            </div>
            <a routerLink='/menu-v1' class="btn-custom">Check our Menu</a>
          </div>
        </div>

      </div>
    </div>
  </div>
  <!-- About us End -->

  <!-- Categories Start -->
  <div class="ct-categories">

    <!-- Category Start -->
    <div class="ct-category">
      <div class="ct-category-bg" style="background-image: url('assets/img/categories-lg/4.jpg')"></div>
      <div class="ct-category-content">
        <div class="ct-category-content-inner">

          <div class="section-title-wrap section-header">
            <h5 class="custom-primary">Pizza Menu</h5>
            <h2 class="title">Our Passion, Our Heritage, Our Pizzas </h2>
            <p class="subtitle">
              Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy
            </p>
          </div>

          <!-- Menu Start -->
          <div class="row">
            <div class="col-lg-6">
              <div class="ct-mini-menu-item">
                <div class="ct-mini-menu-top">
                  <h5>Pepperoni Pizza</h5>
                  <div class="ct-mini-menu-dots"></div>
                  <span class="custom-primary">14.99$</span>
                </div>
                <div class="ct-mini-menu-bottom">
                  <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry Lorem Ipsum has been.</p>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="ct-mini-menu-item">
                <div class="ct-mini-menu-top">
                  <h5>Four Cheese</h5>
                  <div class="ct-mini-menu-dots"></div>
                  <span class="custom-primary">13.99$</span>
                </div>
                <div class="ct-mini-menu-bottom">
                  <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry Lorem Ipsum has been.</p>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="ct-mini-menu-item">
                <div class="ct-mini-menu-top">
                  <h5>Vegetarian</h5>
                  <div class="ct-mini-menu-dots"></div>
                  <span class="custom-primary">9.99$</span>
                </div>
                <div class="ct-mini-menu-bottom">
                  <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry Lorem Ipsum has been.</p>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="ct-mini-menu-item">
                <div class="ct-mini-menu-top">
                  <h5>Barbeque Chicken</h5>
                  <div class="ct-mini-menu-dots"></div>
                  <span class="custom-primary">13.99$</span>
                </div>
                <div class="ct-mini-menu-bottom">
                  <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry Lorem Ipsum has been.</p>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="ct-mini-menu-item">
                <div class="ct-mini-menu-top">
                  <h5>Ham & Cheese</h5>
                  <div class="ct-mini-menu-dots"></div>
                  <span class="custom-primary">11.99$</span>
                </div>
                <div class="ct-mini-menu-bottom">
                  <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry Lorem Ipsum has been.</p>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="ct-mini-menu-item">
                <div class="ct-mini-menu-top">
                  <h5>Specialty Pizza</h5>
                  <div class="ct-mini-menu-dots"></div>
                  <span class="custom-primary">10.99$</span>
                </div>
                <div class="ct-mini-menu-bottom">
                  <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry Lorem Ipsum has been.</p>
                </div>
              </div>
            </div>
          </div>
          <!-- Menu End -->

        </div>
      </div>
    </div>
    <!-- Category End -->

    <!-- Category Start -->
    <div class="ct-category">
      <div class="ct-category-content">
        <div class="ct-category-content-inner">

          <div class="section-title-wrap section-header">
            <h5 class="custom-primary">Pasta Menu</h5>
            <h2 class="title">Did Someone Say Italian Food?</h2>
            <p class="subtitle">
              Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy
            </p>
          </div>

          <!-- Menu Start -->
          <div class="row">
            <div class="col-lg-6">
              <div class="ct-mini-menu-item">
                <div class="ct-mini-menu-top">
                  <h5>Pesto Pasta</h5>
                  <div class="ct-mini-menu-dots"></div>
                  <span class="custom-primary">14.99$</span>
                </div>
                <div class="ct-mini-menu-bottom">
                  <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry Lorem Ipsum has been.</p>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="ct-mini-menu-item">
                <div class="ct-mini-menu-top">
                  <h5>Fettucini</h5>
                  <div class="ct-mini-menu-dots"></div>
                  <span class="custom-primary">13.99$</span>
                </div>
                <div class="ct-mini-menu-bottom">
                  <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry Lorem Ipsum has been.</p>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="ct-mini-menu-item">
                <div class="ct-mini-menu-top">
                  <h5>Chicken Alfredo</h5>
                  <div class="ct-mini-menu-dots"></div>
                  <span class="custom-primary">9.99$</span>
                </div>
                <div class="ct-mini-menu-bottom">
                  <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry Lorem Ipsum has been.</p>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="ct-mini-menu-item">
                <div class="ct-mini-menu-top">
                  <h5>Linguini</h5>
                  <div class="ct-mini-menu-dots"></div>
                  <span class="custom-primary">13.99$</span>
                </div>
                <div class="ct-mini-menu-bottom">
                  <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry Lorem Ipsum has been.</p>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="ct-mini-menu-item">
                <div class="ct-mini-menu-top">
                  <h5>Mac & Cheese</h5>
                  <div class="ct-mini-menu-dots"></div>
                  <span class="custom-primary">11.99$</span>
                </div>
                <div class="ct-mini-menu-bottom">
                  <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry Lorem Ipsum has been.</p>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="ct-mini-menu-item">
                <div class="ct-mini-menu-top">
                  <h5>Italian Specialty</h5>
                  <div class="ct-mini-menu-dots"></div>
                  <span class="custom-primary">10.99$</span>
                </div>
                <div class="ct-mini-menu-bottom">
                  <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry Lorem Ipsum has been.</p>
                </div>
              </div>
            </div>
          </div>
          <!-- Menu End -->

        </div>
      </div>
      <div class="ct-category-bg" style="background-image: url('assets/img/categories-lg/5.jpg')"></div>

    </div>
    <!-- Category End -->

  </div>
  <!-- Categories End -->

  <!-- Products Start -->
  <div class="section products-section">
    <div class="container">

      <div class="section-title-wrap section-header text-center">
        <h5 class="custom-primary">Trending</h5>
        <h2 class="title">Our Customers' Top Picks</h2>
        <p class="subtitle">
          Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy
        </p>
      </div>

      <div class="product-slider">

        <!-- Product Start -->
        <div class="product">
          <a class="product-thumb" routerLink='/menu-item-v1'> <img src="assets/img/prods-sm/5.png" alt="menu item" /> </a>
          <div class="product-body">
            <div class="product-desc">
              <h4> <a routerLink='/menu-item-v1'>Pepperoni</a> </h4>
              <p>Li Europan lingues es membres del sam familie. Lor separat existentie es un myth. Por scientie, musica, sport etc</p>
              <p class="product-price">12.99$</p>
              <div class="favorite">
                <i class="far fa-heart"></i>
              </div>
            </div>
            <div class="product-controls">
              <a href="#" class="order-item btn-custom btn-sm shadow-none">Order <i class="fas fa-shopping-cart"></i> </a>
              <a href="#" class="btn-custom secondary btn-sm shadow-none" data-toggle="modal" data-target="#customizeModal"> Customize <i class="fas fa-plus"></i> </a>
            </div>
          </div>
        </div>
        <!-- Product End -->

        <!-- Product Start -->
        <div class="product">
          <a class="product-thumb" routerLink='/menu-item-v1'> <img src="assets/img/prods-sm/2.png" alt="menu item" /> </a>
          <div class="product-body">
            <div class="product-desc">
              <h4> <a routerLink='/menu-item-v1'>Four Cheese</a> </h4>
              <p>Li Europan lingues es membres del sam familie. Lor separat existentie es un myth. Por scientie, musica, sport etc</p>
              <p class="product-price">13.99$</p>
              <div class="favorite">
                <i class="far fa-heart"></i>
              </div>
            </div>
            <div class="product-controls">
              <a href="#" class="order-item btn-custom btn-sm shadow-none">Order <i class="fas fa-shopping-cart"></i> </a>
              <a href="#" class="btn-custom secondary btn-sm shadow-none" data-toggle="modal" data-target="#customizeModal"> Customize <i class="fas fa-plus"></i> </a>
            </div>
          </div>
        </div>
        <!-- Product End -->

        <!-- Product Start -->
        <div class="product">
          <a class="product-thumb" routerLink='/menu-item-v1'> <img src="assets/img/prods-sm/3.png" alt="menu item" /> </a>
          <div class="product-body">
            <div class="product-desc">
              <h4> <a routerLink='/menu-item-v1'>Vegetarian</a> </h4>
              <p>Li Europan lingues es membres del sam familie. Lor separat existentie es un myth. Por scientie, musica, sport etc</p>
              <p class="product-price">9.99$</p>
              <div class="favorite">
                <i class="far fa-heart"></i>
              </div>
            </div>
            <div class="product-controls">
              <a href="#" class="order-item btn-custom btn-sm shadow-none">Order <i class="fas fa-shopping-cart"></i> </a>
              <a href="#" class="btn-custom secondary btn-sm shadow-none" data-toggle="modal" data-target="#customizeModal"> Customize <i class="fas fa-plus"></i> </a>
            </div>
          </div>
        </div>
        <!-- Product End -->

        <!-- Product Start -->
        <div class="product">
          <a class="product-thumb" routerLink='/menu-item-v1'> <img src="assets/img/prods-sm/4.png" alt="menu item" /> </a>
          <div class="product-body">
            <div class="product-desc">
              <h4> <a routerLink='/menu-item-v1'>Barbeque Chicken</a> </h4>
              <p>Li Europan lingues es membres del sam familie. Lor separat existentie es un myth. Por scientie, musica, sport etc</p>
              <p class="product-price">11.99$</p>
              <div class="favorite">
                <i class="far fa-heart"></i>
              </div>
            </div>
            <div class="product-controls">
              <a href="#" class="order-item btn-custom btn-sm shadow-none">Order <i class="fas fa-shopping-cart"></i> </a>
              <a href="#" class="btn-custom secondary btn-sm shadow-none" data-toggle="modal" data-target="#customizeModal"> Customize <i class="fas fa-plus"></i> </a>
            </div>
          </div>
        </div>
        <!-- Product End -->

      </div>

      <div class="ct-arrows centered-arrows">
        <i class="slider-prev fas fa-arrow-left slick-arrow"></i>
        <i class="slider-next fas fa-arrow-right slick-arrow"></i>
      </div>

    </div>
  </div>
  <!-- Products End -->

  <!-- Order Online Start -->
  <div class="container">
    <div class="section text-center cta bg-cover bg-center dark-overlay dark-overlay-2 bg-parallax" style="background-image: url('assets/img/bg/cta.jpg')">
      <div class="section-title-wrap section-header text-center">
        <h5 class="custom-primary">Order Online</h5>
        <h2 class="title text-white">Get 10% Off Your First Order</h2>
        <p class="subtitle text-white">
          Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s
        </p>
      </div>
      <a routerLink='/menu-v1' class="btn-custom shadow-none">Order Online</a>
    </div>
  </div>
  <!-- Order Online End -->

  <!-- Testimonials Start -->
  <section class="section testimonials">
    <div class="container">
      <div class="section-title-wrap section-header text-center">
        <h5 class="custom-primary">Our Backbone</h5>
        <h2 class="title">Customer Testimonials</h2>
        <p class="subtitle">
          Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s
        </p>
      </div>

      <div class="ct-testimonials-slider">

        <!-- Testimonial item start -->
        <div class="ct-testimonial-slider-item">
          <div class="ct-testimonial-item">
            <div class="ct-testimonial-thumb">
              <img src="assets/img/people/1.jpg" alt="person">
            </div>
            <div class="ct-testimonial-content">
              <i class="flaticon-left-quote"></i>
              <p>
                Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s
              </p>
              <h5>John Doe</h5>
              <span>Food Specialist</span>
            </div>
          </div>
        </div>
        <!-- Testimonial item end -->

        <!-- Testimonial item start -->
        <div class="ct-testimonial-slider-item">
          <div class="ct-testimonial-item">
            <div class="ct-testimonial-thumb">
              <img src="assets/img/people/2.jpg" alt="person">
            </div>
            <div class="ct-testimonial-content">
              <i class="flaticon-left-quote"></i>
              <p>
                Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s
              </p>
              <h5>Heather Madlin</h5>
              <span>Food Specialist</span>
            </div>
          </div>
        </div>
        <!-- Testimonial item end -->

        <!-- Testimonial item start -->
        <div class="ct-testimonial-slider-item">
          <div class="ct-testimonial-item">
            <div class="ct-testimonial-thumb">
              <img src="assets/img/people/3.jpg" alt="person">
            </div>
            <div class="ct-testimonial-content">
              <i class="flaticon-left-quote"></i>
              <p>
                Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s
              </p>
              <h5>Tina Flinston</h5>
              <span>Food Specialist</span>
            </div>
          </div>
        </div>
        <!-- Testimonial item end -->

        <!-- Testimonial item start -->
        <div class="ct-testimonial-slider-item">
          <div class="ct-testimonial-item">
            <div class="ct-testimonial-thumb">
              <img src="assets/img/people/4.jpg" alt="person">
            </div>
            <div class="ct-testimonial-content">
              <i class="flaticon-left-quote"></i>
              <p>
                Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s
              </p>
              <h5>Justine Donawick</h5>
              <span>Food Specialist</span>
            </div>
          </div>
        </div>
        <!-- Testimonial item end -->

      </div>

      <div class="ct-arrows centered-arrows with-margin">
        <i class="fas fa-arrow-left slider-prev"></i>
        <i class="fas fa-arrow-right slider-next"></i>
      </div>

    </div>
  </section>
  <!-- Testimonials End -->

  <!-- Instagram Start -->
  <div class="row no-gutters">
    <div class="col-lg-2 col-md-4 col-sm-4 col-6 p-0">
      <a href="#" class="ct-ig-item">
        <img src="assets/img/ig/1.jpg" alt="ig">
      </a>
    </div>
    <div class="col-lg-2 col-md-4 col-sm-4 col-6 p-0">
      <a href="#" class="ct-ig-item">
        <img src="assets/img/ig/2.jpg" alt="ig">
      </a>
    </div>
    <div class="col-lg-2 col-md-4 col-sm-4 col-6 p-0">
      <a href="#" class="ct-ig-item">
        <img src="assets/img/ig/3.jpg" alt="ig">
      </a>
    </div>
    <div class="col-lg-2 col-md-4 col-sm-4 col-6 p-0">
      <a href="#" class="ct-ig-item">
        <img src="assets/img/ig/4.jpg" alt="ig">
      </a>
    </div>
    <div class="col-lg-2 col-md-4 col-sm-4 col-6 p-0">
      <a href="#" class="ct-ig-item">
        <img src="assets/img/ig/5.jpg" alt="ig">
      </a>
    </div>
    <div class="col-lg-2 col-md-4 col-sm-4 col-6 p-0">
      <a href="#" class="ct-ig-item">
        <img src="assets/img/ig/6.jpg" alt="ig">
      </a>
    </div>
  </div>
  <!-- Instagram End -->

<app-footer></app-footer>